import Box from '@mui/material/Box'
import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'
import Diversity1Icon from '@mui/icons-material/Diversity1'
import GridViewIcon from '@mui/icons-material/GridView'
import { useState } from 'react'
import { GameCreators } from './GameCreators'

function GameToolbar() {
  const [authorOpen, setAuthorOpen] = useState(false)
  const handleAuthorOpen = () => setAuthorOpen(true)
  const handleAuthorClose = () => setAuthorOpen(false)

  return (
    <>
      <Box
        sx={{
          zIndex: 1,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          flexDirection: 'row',
          textAlign: 'start',
          alignItems: 'center',
          py: 2,
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/app_logo.png`}
          height={64}
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, px: 2 }}>
          <Fab
            size="small"
            color="default"
            aria-label="add"
            onClick={handleAuthorOpen}
          >
            <Diversity1Icon />
          </Fab>
        </Box>
      </Box>
      <GameCreators open={authorOpen} handleClose={handleAuthorClose} />
    </>
  )
}

export default GameToolbar
